import { Button, Container, Grid, Tooltip } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { functions, instance, validateFunction } from "../Components/config";
import { useAuth } from "../Components/AuthContext";
import { DialogAlert } from "../Components/DialogAlert";
import { useLocation, useNavigate } from "react-router-dom";
import { TextFieldDisabled } from "../Components/TextFieldDisabled";
import MaterialReactTable from "material-react-table";
import { AlertDialog } from "../Components/AlertDialog";
import { LoaderBox } from "../Components/LoaderBox";
import { BackButton } from "../Components/BackButton";

function Actividad() {
  const { state } = useLocation();
  const { id } = state;
  const [openDialog, setOpenDialog] = useState(false);
  const [isLoading, setLoading] = useState(true);
  const [actividad, setActividad] = useState({});
  const [unidades, setUnidades] = useState([]);
  const { user } = useAuth();
  const [openAlertDialog, setOpenAlertDialog] = useState(false);
  const [alertDialog, setAlertDialog] = useState({});
  const [dialog, setDialog] = useState({});
  const navigate = useNavigate();

  const columns = useMemo(() => [
    {
      accessorKey: "categoria",
      header: "Categoría",
      size: 50,
    },
    {
      accessorKey: "unidad",
      header: "Unidad",
      size: 50,
    },
    {
      accessorKey: "cantidad",
      header: "Cantidad",
      size: 50,
    },
  ]);

  if (isLoading) {
    async function getItems() {
      try {
        const { data } = await instance.get("/actividad/getById/" + id);
        setUnidades(
          data.unidades.split(";|||//|||;").map((item) => {
            const unidad = item.split(";//|||//;");
            return {
              categoria: unidad[0],
              unidad: unidad[1],
              cantidad: unidad[2],
            };
          })
        );
        delete data.unidades;
        setActividad(data);
      } catch (error) {
        alert(error);
      }
    }
    getItems();
    setLoading(false);
  }

  const eliminarActividad = () => {
    setAlertDialog({
      title: "Alerta",
      text: `¿Seguro que deseas eliminar la actividad?`,
    });
    setOpenAlertDialog(true);
  };

  const yesClick = () => {
    handleEliminar();
    setOpenAlertDialog(false);
  };
  const noClick = () => {
    setOpenAlertDialog(false);
  };

  const handleEliminar = () => {
    instance
      .delete(`actividad/`, {
        data: {
          id: id,
          user: user.id,
        },
      })
      .then((res) => {
        setDialog({
          title: "Aviso",
          text: `Se ha eliminado la actividad.`,
          redirect: true,
          page: "/UPSE1",
          pageState: { id: actividad.upseId },
        });
        setOpenDialog(true);
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response.data.message });
        }
        setOpenDialog(true);
      })
      .finally();
  };

  return (
    <LoaderBox isLoading={isLoading}>
      <Container
        maxWidth="lg"
        sx={{ border: { xs: "0", sm: "1px solid #000" }, mt: 2 }}
      >
        <Grid container>
          <Grid item xs={12} sm={6}>
            <Grid container spacing={3} padding={2} rowSpacing={1}>
              <Grid item xs={12}>
                <TextFieldDisabled title={"UPSE"} value={actividad.upse} />
              </Grid>
              <Grid item xs={12}>
                <TextFieldDisabled
                  title={"Responsable"}
                  value={actividad.responsable}
                />
              </Grid>
              <Grid item xs={12}>
                <TextFieldDisabled
                  title={"Descripción"}
                  value={actividad.descripcion}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextFieldDisabled
                  title={"Catálogo"}
                  value={actividad.catalogo}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextFieldDisabled
                  title={"Producto"}
                  value={actividad.producto}
                />
              </Grid>

              <Grid item xs={12}>
                <MaterialReactTable
                  columns={columns}
                  data={unidades}
                  enableColumnActions={false}
                  enableColumnFilters={false}
                  enablePagination={false}
                  enableSorting={false}
                  enableBottomToolbar={false}
                  enableTopToolbar={false}
                  muiTableBodyRowProps={{ hover: false }}
                  muiTableProps={{
                    sx: {
                      border: "1px solid rgba(81, 81, 81, 1)",
                    },
                  }}
                  muiTableHeadCellProps={{
                    sx: {
                      border: "1px solid rgba(81, 81, 81, 1)",
                    },
                  }}
                  muiTableBodyCellProps={{
                    sx: {
                      border: "1px solid rgba(81, 81, 81, 1)",
                    },
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Grid container spacing={3} padding={2} rowSpacing={1}>
              <Grid item xs={12} sm={6}>
                <TextFieldDisabled
                  title={"Departamento"}
                  value={actividad.departamento}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextFieldDisabled
                  title={"Municipio"}
                  value={actividad.municipio}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextFieldDisabled
                  title={"Coordenadas"}
                  value={actividad.coordenadas}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextFieldDisabled
                  title={"Presupuesto Aprobado"}
                  value={actividad.aprobado}
                />
              </Grid>
              <Grid item xs={12}>
                <TextFieldDisabled
                  title={"Localidad"}
                  value={actividad.localidad}
                />
              </Grid>
              <Grid item xs={12}>
                <TextFieldDisabled
                  title={"Meta según PEI"}
                  value={actividad.meta}
                />
              </Grid>
              <Grid item xs={12}>
                <TextFieldDisabled
                  title={"Resultado esperado"}
                  value={actividad.resultado}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid
              container
              sx={{
                display: "flex",
                flexDirection: "row",
              }}
              spacing={4}
            >
              <Grid
                item
                xs={12}
                sm={3}
                sx={{
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                }}
              >
                {validateFunction(user, functions.ModifyActivity) && (
                  <Button
                    type="submit"
                    onClick={() => {
                      navigate("/ActividadEditar", {
                        state: { id: actividad.id },
                      });
                    }}
                    variant="contained"
                    className="warningBg"
                    sx={{ mb: 2 }}
                    padding={1}
                  >
                    Editar Actividad
                  </Button>
                )}
              </Grid>
              <Grid
                item
                xs={12}
                sm={3}
                sx={{
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                }}
              >
                {validateFunction(user, functions.CreateSeguimiento) && (
                  <Tooltip
                    title={
                      actividad.seguimientos === 12
                        ? "Esta actividad ya tiene 12 seguimientos registrados, no se pueden agregar más."
                        : ""
                    }
                    placement="top"
                  >
                    <span>
                      <Button
                        type="submit"
                        onClick={() => {
                          navigate("/SeguimientoAgregar", {
                            state: { id: actividad.id },
                          });
                        }}
                        variant="contained"
                        color="success"
                        sx={{ mb: 2 }}
                        padding={1}
                        disabled={actividad.seguimientos === 12}
                      >
                        Agregar Seguimiento
                      </Button>
                    </span>
                  </Tooltip>
                )}
              </Grid>
              <Grid
                item
                xs={12}
                sm={3}
                sx={{
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                }}
              >
                <Button
                  onClick={() => {
                    navigate("/Seguimientos", {
                      state: { id: actividad.id },
                    });
                  }}
                  variant="contained"
                  color="info"
                  sx={{ mb: 2 }}
                  padding={1}
                >
                  Seguimientos
                </Button>
              </Grid>
              <Grid
                item
                xs={12}
                sm={3}
                sx={{
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                }}
              >
                {validateFunction(user, functions.DeleteActivity) && (
                  <Tooltip
                    title={
                      actividad.seguimientos !== 0
                        ? "Esta actividad no puede ser eliminada porque tiene seguimientos registrados."
                        : ""
                    }
                    placement="top"
                  >
                    <span>
                      <Button
                        onClick={eliminarActividad}
                        variant="contained"
                        color="error"
                        sx={{ mb: 2 }}
                        padding={1}
                        disabled={actividad.seguimientos !== 0}
                      >
                        Eliminar
                      </Button>
                    </span>
                  </Tooltip>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
      <DialogAlert
        title={dialog.title}
        text={dialog.text}
        open={openDialog}
        setOpen={setOpenDialog}
        redirectOnClose={dialog.redirect}
        page={dialog.page}
        pageState={dialog.pageState}
      />
      <AlertDialog
        open={openAlertDialog}
        accept={yesClick}
        acceptText={"Aceptar"}
        decline={noClick}
        declineText={"Cancelar"}
        title={alertDialog.title}
        text={alertDialog.text}
      />
      <BackButton pageState={{id:actividad.upseId}} page="/UPSE1" text="Ver UPSE" />
    </LoaderBox>
  );
}

export { Actividad };
